import * as angular from "angular";
import filtersModule from "./filters/filters.module";
import formModule from "./brd-form/brd-form.module";

export default angular
    .module("board.web.admin.common", [
        filtersModule,
        formModule
    ])
    .name;


// WEBPACK FOOTER //
// ./app/common/app.common.ts